// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { CheckCircle2 } from 'lucide-react'

interface ClosingGuidanceProps {
  title:    string
  children: React.ReactNode
}

/**
 * Afsluitend begeleidingsblok.
 * Ontwerpprincipe: iedere kernpagina eindigt met een rustige, positieve of begeleidende
 * afsluiting - niet met een waarschuwing of juridisch blok, maar met een gevoel van rust en regie.
 * De vormgeving is overal gelijk; de titel en tekst zijn per module verschillend, zodat elke
 * pagina aanvoelt alsof hij echt over dat onderwerp gaat.
 */
export function ClosingGuidance({ title, children }: ClosingGuidanceProps) {
  return (
    <div className="rounded-2xl border border-l-4 border-sage-200 border-l-sage-500 bg-sage-50 px-4 py-3.5">
      <div className="flex items-start gap-2.5">
        <CheckCircle2 className="h-4 w-4 text-sage-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
        <div>
          <p className="text-sm font-semibold text-ink-2 mb-1">{title}</p>
          <p className="text-[13px] leading-relaxed text-ink-3">{children}</p>
        </div>
      </div>
    </div>
  )
}
